<template>
  <button
  >
    <span>{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: "GuestButton",
  props: {
    text: String,
  },
};
</script>

<style lang="scss" scoped>
button {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  line-height: 1;
  letter-spacing: 0;
  text-align: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  user-select: none;
  &.selected span {
    background: linear-gradient(96.44deg, #C88A65 19.42%, #F0B392 44.38%, #C88A65 69.75%);
    border:1px solid var(--grey);
    color: var(--dark-grey);
  }
  @media (hover: hover) {
    &:hover {
      span {
        background: rgba(255, 168, 120, 0.4);  
        border:1px solid var(--accent);      
      }
    }
  }
  span {
    transition: 0.2s all ease-in-out;
    width: 20px;
    height: 20px;
    display: grid;
    place-items: center;
    border:1px solid var(--grey);      
    background: rgba(255, 255, 255, 0.2);
    padding: 5px;
    color: var(--white);
    line-height: 1rem;
  }
}
</style>